<template>
	<div v-show="show">
		<vs-row v-if="teamUpdatePermission">
			<div class="vx-col w-full mb-base p-4">
				<vx-card>
					<div>
						<TeamsForm :data="item" :isEditActive="true" :key="key" />
					</div>
				</vx-card>
			</div>
		</vs-row>
		<not-permission v-else></not-permission>
	</div>
</template>
<script>
import Api from "@/helpers/api.js";
import TeamsForm from "@/components/teams/TeamsForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Team",
	data() {
		return {
			item: {},
			key: 1,
			show: false,
		};
	},
	components: {
		TeamsForm,
		NotPermission,
	},
	methods: {
		getTeamData(id) {
			return new Promise((resolve, reject) => {
				Api.get("/team/" + id)
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
	},
	computed: {
		teamUpdatePermission() {
			return this.$store.getters.checkPermission("TEAMS_U");
		},
	},
	created() {
		this.getTeamData(this.$route.params.id).then((result) => {
			this.item = result.data;
			this.key++;
		});
	},
	mounted() {
		this.show = true;
	},
};
</script>
